// extracted by mini-css-extract-plugin
export default {"Hit":"Hit_Hit__kEZ-x","icon":"Hit_icon__3QUlR","title":"Hit_title__fIi+z","text":"Hit_text__1UGiw","link":"Hit_link__WMQAa"};